// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --production` replaces `environment.ts` with `environment.production.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	useStage: false,
	ppTest: true, // paypal environment
	// api: 'https://live.v-locker.ch',
	api: 'https://test.v-locker.ch',
	// api: 'http://localhost:4200',
	testApi: 'https://stage.v-locker.ch',
	erpApi: 'https://erp-test.v-locker.ch',
	// api: 'https://live.v-locker.ch',
	disableLogs: false,
	distanceChecking: 2000000,
	paypalReturnUrl: 'http://127.0.0.1:4200/app/settings',
	giropayReturnUrl: 'http://localhost:8100/payment',
	payrexxTwintReturnUrl: 'http://localhost:8100/payment',
	logzIoUrl: 'https://listener-eu.logz.io:8071',
	// testAppVersion: '1.6.1.27',
	testAppVersion: '1.7.0.1',
	oauthUrl: '/oauth2/authorize/',
	oauthReturnUrl: '/app/oauth2/redirect',
	oauthLocalReturnUrl: '/app/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
